/* PetNugget welcome offer. Public Klaviyo client API only; checkout owns eligibility. */
(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!host || !host.document) return;
  function boot(scope) {
    scope.querySelectorAll('[data-pn-welcome]').forEach(function (element) { api.mount(element, host); });
  }
  if (host.document.readyState === 'loading') host.document.addEventListener('DOMContentLoaded', function () { boot(host.document); });
  else boot(host.document);
  host.document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var DAY = 86400000;
  var STATE_KEY = 'petnugget.welcome.v1';
  var COUNTRY_KEY = 'petnugget.welcome.country.v1';
  var AGE_VALUES = ['puppy', '1-3', '4-7', '8+'];

  function entries(value) {
    return (Array.isArray(value) ? value : String(value || '').split(/[\n,]/)).map(function (item) { return item.trim(); }).filter(Boolean);
  }
  function excluded(url, config) {
    var path = url.pathname.replace(/\/$/, '') || '/';
    var rootPath = String(config.rootUrl || '/').replace(/\/$/, '');
    if (rootPath && (path === rootPath || path.indexOf(rootPath + '/') === 0)) path = path.slice(rootPath.length) || '/';
    var paths = ['/cart', '/checkout', '/checkouts', '/account', '/challenge', '/password', '/policies'].concat(entries(config.excludedPaths));
    if (paths.some(function (prefix) {
      prefix = prefix.replace(/\/$/, '');
      return prefix && (path === prefix || path.indexOf(prefix + '/') === 0);
    })) return true;
    return entries(config.excludedCampaigns).indexOf(url.searchParams.get('utm_campaign') || '') !== -1;
  }
  function normalizedFields(fields) {
    return { pet_name: String(fields.pet_name || '').trim(), pet_age_range: String(fields.pet_age_range || ''), email: String(fields.email || '').trim() };
  }
  function validFields(fields) {
    return fields.pet_name.length > 0 && fields.pet_name.length <= 64 && AGE_VALUES.indexOf(fields.pet_age_range) !== -1 && fields.email.length <= 254 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email);
  }
  function subscriptionPayload(fields, listId) {
    fields = normalizedFields(fields);
    if (!validFields(fields) || !/^[a-zA-Z0-9]{6}$/.test(String(listId))) throw new Error('Invalid signup');
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'PetNugget US fullscreen welcome',
          profile: { data: { type: 'profile', attributes: {
            email: fields.email,
            properties: { pet_name: fields.pet_name, pet_age_range: fields.pet_age_range, petnugget_signup_source: 'fullscreen_welcome' },
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
  }
  function detectedCountry(result) {
    var value = result && result.detected_values && result.detected_values.country && result.detected_values.country.handle;
    return typeof value === 'string' && /^[A-Z]{2}$/.test(value) ? value : null;
  }
  function read(storage, key) {
    try { var value = JSON.parse(storage.getItem(key)); return value && typeof value === 'object' ? value : {}; } catch (_) { return {}; }
  }
  function write(storage, key, value) { try { storage.setItem(key, JSON.stringify(value)); } catch (_) { /* Private browsing may disable storage. */ } }
  function stateFlags(state, now) {
    return { complete: Number(state.completedUntil) > now, autoDismissed: Number(state.autoDismissedUntil) > now, tabDismissed: Number(state.tabDismissedUntil) > now };
  }
  function isSearchReferral(referrer) {
    try { return /(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.com)$/.test(new URL(referrer).hostname); } catch (_) { return false; }
  }

  function mount(root, win) {
    if (root.dataset.pnWelcomeMounted) return;
    root.dataset.pnWelcomeMounted = 'true';
    var config;
    try { config = JSON.parse(root.querySelector('[data-pn-welcome-config]').textContent); } catch (_) { return; }
    var dialog = root.querySelector('[data-pn-welcome-dialog]');
    var teaser = root.querySelector('[data-pn-welcome-teaser]');
    var form = root.querySelector('[data-pn-welcome-form]');
    var error = root.querySelector('[data-pn-welcome-error]');
    var submit = root.querySelector('[data-pn-welcome-submit]');
    if (!dialog || !teaser || !form || !error || !submit || typeof dialog.showModal !== 'function') return;
    var designMode = config.designMode === true;
    var url = new URL(win.location.href);
    if (!designMode && (!config.enabled || config.knownIneligible || excluded(url, config))) return;
    if (!designMode && (!/^[a-zA-Z0-9]{6}$/.test(config.companyId || '') || !/^[a-zA-Z0-9]{6}$/.test(config.listId || ''))) return;
    var localStorage, sessionStorage;
    try { localStorage = win.localStorage; sessionStorage = win.sessionStorage; } catch (_) { /* Memory-only state is still usable. */ }
    var state = read(localStorage, STATE_KEY);
    var flags = stateFlags(state, Date.now());
    if (!designMode && (flags.complete || flags.tabDismissed)) return;
    var eligible = designMode;
    var currentStep = 'offer';
    var completed = false;
    var pending = false;
    var retryAfter = 0;
    var autoAttempted = false;
    var autoDelayPassed = false;
    var destroyed = false;
    var lastFocus = null;
    var oldBodyOverflow = '';
    var listeners = new AbortController();
    var signal = listeners.signal;
    var cooldown = Math.max(1, Math.min(365, Number(config.cooldownDays) || 30)) * DAY;
    var scrollTarget = Math.max(0, Math.min(100, Number.isFinite(Number(config.scrollPercent)) ? Number(config.scrollPercent) : 30));
    var desktop = win.matchMedia('(min-width: 990px) and (pointer: fine)');
    var delayTimer;

    function persist() { if (!designMode) write(localStorage, STATE_KEY, state); }
    function track(action, source) {
      if (designMode) return;
      // Event data deliberately excludes the email address and pet details.
      root.dispatchEvent(new CustomEvent('petnugget:welcome', { bubbles: true, detail: { action: action, source: source || 'popup' } }));
    }
    function setStep(step) {
      currentStep = step;
      root.querySelectorAll('[data-pn-welcome-step]').forEach(function (panel) { panel.hidden = panel.dataset.pnWelcomeStep !== step; });
      dialog.dataset.step = step;
      dialog.scrollTop = 0;
      var title = root.querySelector('[data-pn-welcome-step="' + step + '"] h2');
      if (title && title.id) dialog.setAttribute('aria-labelledby', title.id);
      if (dialog.open) {
        // Keep the mobile keyboard closed until the visitor taps a field.
        var target = title || dialog;
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }
    function otherOverlayOpen() {
      var cart = win.document.getElementById('cart-drawer');
      return (cart && !cart.hidden) || Array.from(win.document.querySelectorAll('dialog[open]')).some(function (item) { return item !== dialog; });
    }
    function open(step, source) {
      if (!eligible || completed || dialog.open || pending) return;
      if (source === 'automatic' && otherOverlayOpen()) return;
      autoAttempted = true;
      lastFocus = win.document.activeElement;
      oldBodyOverflow = win.document.body.style.overflow;
      win.document.body.style.overflow = 'hidden';
      teaser.hidden = true;
      setStep(step);
      dialog.showModal();
      setStep(step);
      track('open', source);
    }
    function close() {
      if (!dialog.open) return;
      dialog.close();
    }
    function handleClose() {
      win.document.body.style.overflow = oldBodyOverflow;
      if (!completed) {
        state.autoDismissedUntil = Date.now() + cooldown;
        persist();
        teaser.hidden = !eligible;
      }
      if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
      track('close');
    }
    function maybeAutoOpen() {
      if (!eligible || designMode || !desktop.matches || !autoDelayPassed || autoAttempted || flags.autoDismissed || win.document.visibilityState !== 'visible' || isSearchReferral(win.document.referrer)) return;
      if (/^(INPUT|TEXTAREA|SELECT)$/.test(win.document.activeElement.tagName) || win.document.activeElement.isContentEditable || otherOverlayOpen()) return;
      var max = win.document.documentElement.scrollHeight - win.innerHeight;
      var scrolled = max > 0 ? win.scrollY / max * 100 : 0;
      if (scrolled >= scrollTarget) open('offer', 'automatic');
    }
    function showError(message) { error.textContent = message; error.hidden = false; }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-pn-welcome-action]');
      if (!button || !root.contains(button)) return;
      var action = button.dataset.pnWelcomeAction;
      if (action === 'open') { event.preventDefault(); open('details', 'tab'); }
      else if (action === 'next') { event.preventDefault(); setStep('details'); track('step_two'); }
      else if (action === 'back') { event.preventDefault(); setStep('offer'); }
      else if (action === 'close') { event.preventDefault(); close(); }
      else if (action === 'dismiss-tab') {
        event.preventDefault();
        state.autoDismissedUntil = state.tabDismissedUntil = Date.now() + cooldown;
        persist(); teaser.hidden = true; autoAttempted = true; track('dismiss_tab');
      } else if (action === 'shop') { close(); }
    }, { signal: signal });
    dialog.addEventListener('close', handleClose, { signal: signal });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); }, { signal: signal });
    form.addEventListener('input', function () { error.hidden = true; }, { signal: signal });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (pending || completed) return;
      if (Date.now() < retryAfter) { showError('Please wait a moment, then try again.'); return; }
      if (!form.reportValidity()) return;
      var data = new FormData(form);
      var fields = normalizedFields({ pet_name: data.get('pet_name'), pet_age_range: data.get('pet_age_range'), email: data.get('email') });
      if (!validFields(fields) || data.get('website')) { showError('Please check your details and try again.'); return; }
      if (designMode) {
        root.querySelectorAll('[data-pn-welcome-success-name]').forEach(function (node) { node.textContent = fields.pet_name; });
        setStep('success'); return;
      }
      if (!eligible) { showError('This offer is available to US customers only.'); return; }
      pending = true; error.hidden = true;
      var buttonLabel = submit.textContent;
      submit.disabled = true; submit.textContent = 'Sending…'; form.setAttribute('aria-busy', 'true');
      var controller = new AbortController();
      var timeout = win.setTimeout(function () { controller.abort(); }, 15000);
      try {
        var response = await win.fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(config.companyId), {
          method: 'POST',
          headers: { Accept: 'application/vnd.api+json', 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(subscriptionPayload(fields, config.listId)),
          signal: controller.signal
        });
        if (response.status === 429) {
          var seconds = Number(response.headers.get('Retry-After'));
          retryAfter = Date.now() + (Number.isFinite(seconds) && seconds > 0 ? Math.min(seconds, 3600) : 30) * 1000;
          throw new Error('rate_limit');
        }
        if (response.status !== 202) throw new Error('not_accepted');
        // 202 may have an empty body. Never claim that acceptance proves delivery.
        completed = true;
        state.completedUntil = Date.now() + 365 * DAY;
        persist();
        teaser.hidden = true;
        root.querySelectorAll('[data-pn-welcome-success-name]').forEach(function (node) { node.textContent = fields.pet_name; });
        setStep('success'); track('signup_accepted');
      } catch (failure) {
        showError(failure.message === 'rate_limit' ? 'Please wait a moment, then try again.' : 'That didn’t go through. Please try again in a moment.');
        track('signup_error');
      } finally {
        win.clearTimeout(timeout); pending = false; submit.disabled = false; submit.textContent = buttonLabel; form.removeAttribute('aria-busy');
      }
    }, { signal: signal });

    async function qualify() {
      if (designMode) { eligible = true; open('offer', 'preview'); return; }
      var cached = read(sessionStorage, COUNTRY_KEY);
      var country = cached.expires > Date.now() && /^[A-Z]{2}$/.test(cached.country || '') ? cached.country : null;
      if (!country) {
        var controller = new AbortController();
        var timer = win.setTimeout(function () { controller.abort(); }, 7000);
        try {
          var rootPath = typeof config.rootUrl === 'string' && config.rootUrl.startsWith('/') && !config.rootUrl.startsWith('//') ? config.rootUrl : '/';
          var response = await win.fetch(rootPath.replace(/\/?$/, '/') + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          country = detectedCountry(await response.json());
          if (country) write(sessionStorage, COUNTRY_KEY, { country: country, expires: Date.now() + 30 * 60000 });
        } catch (_) { return; } finally { win.clearTimeout(timer); }
      }
      // The selected Shopify market is not proof of a visitor's location.
      // Location can arrive after another tab completes or dismisses the offer.
      if (destroyed) return;
      state = read(localStorage, STATE_KEY);
      flags = stateFlags(state, Date.now());
      if (flags.complete || flags.tabDismissed) return;
      eligible = country === 'US';
      if (!eligible) return;
      teaser.hidden = false;
      track('teaser_visible');
      maybeAutoOpen();
    }
    win.addEventListener('scroll', maybeAutoOpen, { passive: true, signal: signal });
    win.document.addEventListener('visibilitychange', maybeAutoOpen, { signal: signal });
    win.addEventListener('storage', function (event) {
      if (event.key !== STATE_KEY) return;
      state = read(localStorage, STATE_KEY); flags = stateFlags(state, Date.now());
      if (flags.complete || flags.tabDismissed) { completed = flags.complete; eligible = false; teaser.hidden = true; close(); }
    }, { signal: signal });
    delayTimer = win.setTimeout(function () { autoDelayPassed = true; maybeAutoOpen(); }, Math.max(5, Number(config.desktopDelaySeconds) || 15) * 1000);
    setStep('offer'); qualify();
    win.document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      destroyed = true;
      if (dialog.open) { dialog.close(); win.document.body.style.overflow = oldBodyOverflow; }
      win.clearTimeout(delayTimer); listeners.abort();
    }, { signal: signal });
  }
  return { mount: mount, excluded: excluded, normalizedFields: normalizedFields, validFields: validFields, subscriptionPayload: subscriptionPayload, detectedCountry: detectedCountry, stateFlags: stateFlags, isSearchReferral: isSearchReferral };
});
